import React from "react";

// Loacal imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";

// Live imports
import { NavLink as Link, withRouter } from "react-router-dom";

function About() {
  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>
                  About <span>Us</span>
                </h1>
                <span className="line"></span>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiu tempor incididunt ut labore et dolore magna aliqua.
                </p>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/about-us" activeclass="active">
                          About Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="about-us" className="inner-page-wrapper about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-9 about-text">
              <h3>
                Since 1975 <span>in serving MCO's.</span>
              </h3>
              <span className="line"></span>

              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                eget odio condimentum, suscipit elit non,sodales mauris. Aliquam
                erat volutpat. Integer eu risus consequat, tempus odio nec,
                hendrerit risus. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Sed eget odio condimentum, suscipit elit. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit. Sed eget odio
                condimentum, suscipit elit non,sodales mauris. Aliquam erat
                volutpat. Integer eu risus consequat, tempus odio nec, hendrerit
                risus. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Sed eget odio condimentum, suscipit elit.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                eget odio condimentum, suscipit elit non,sodales mauris. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum
                dolor sit amet, consectetur adipiscing elit. Sed eget odio
                condimentum, suscipit elit non,sodales mauris.{" "}
              </p>
              <p>
                Contrary to popular belief, Lorem Ipsum is not simply random
                text. It has roots in a piece of classical Latin literature from
                45 BC, making it over 2000 years old. Richard McClintock, a
                Latin professor at Hampden-Sydney College in Virginia, looked up
                one of the more obscure Latin words, consectetur, from a Lorem
                Ipsum passage, and going through the cites of the word in
                classical literature, discovered the undoubtable source. Lorem
                Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus
                Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero,
                written in 45 BC. This book is a treatise on the theory of
                ethics, very popular during the Renaissance. The first line of
                Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line
                in section 1.10.32.
              </p>
            </div>
            <div className="col-xl-3 about-image d-none d-xl-block">
              {" "}
              <img src="/assets/images/about/about-us.png" alt="" />{" "}
            </div>
          </div>
        </div>
      </section>
      <CTAStrip />
    </>
  );
}

export default withRouter(About);
